import React from "react";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../components/ModuleHeader/ModuleHeader";
import ModulePageShell from "../../components/ModulePageShell/ModulePageShell";
import "./report.scss";

const reports = [
  ["Sales Report", "Track total sales, net earnings, total orders, and bags sold.", "/reports/sales"],
  ["Order Performance", "Review paid, collected, cancelled, and refunded order outcomes.", "/reports/order-performance"],
  ["Listing Performance", "Measure bags listed, bags sold, sell-through rate, and unsold bags.", "/reports/listing-performance"],
];

const ReportPage = () => {
  const navigate = useNavigate();

  return (
    <ModulePageShell className="report-page">
      <ModuleHeader
        bleed
        title="Reports"
        description="View weekly and monthly historical performance reports."
      />

      <section className="report-card">
        <div className="report-card__header">
          <div>
            <h3>Report Listing</h3>
            <p>Dashboard focuses on today. Reports focus on historical trends and performance.</p>
          </div>
        </div>
        <div className="report-table report-table--performance">
          <div className="report-table__head">
            <span>Report</span><span>Description</span><span>Default Period</span><span>Actions</span>
          </div>
          {reports.map((row) => (
            <div className="report-table__row" key={row[0]}>
              <span>{row[0]}</span>
              <span>{row[1]}</span>
              <span>This Week</span>
              <button className="report-button report-button--link" type="button" onClick={() => navigate(row[2])}>View</button>
            </div>
          ))}
        </div>
      </section>
    </ModulePageShell>
  );
};

export default ReportPage;
